import { Observable } from 'rxjs'
import { MbProductTabSpecifications } from '../../../models'

export abstract class MbProductTabSpecificationsAdapter {

  abstract load(productCode: string, maxCount?: number): Observable<MbProductTabSpecifications>
}
